import React, { useState, useEffect, useRef } from 'react'
import { styled } from "@mui/material/styles";
import { Container, Box, Paper, Typography, Table, TableBody, TableCell, TableRow, Card, CardContent, Link, Divider, Grid, Button } from "@mui/material";
import { Form, Formik, useFormikContext } from 'formik';
import CustomInputLogin from '../../../../Components/CustomInputLogin/CustomInputLogin';
import CustomDropdownMui from '../../../../Components/CustomDropDown/CustomDropdown';

import FileUploadComponent from '../../../../Components/FileUploadComponent/FileUploadComponent';
import actions from '../../../../ReduxStore/actions';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import * as Yup from 'yup';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';
import MultipleFileUploadComponent from '../../../../Components/FileUploadComponent/MultipleFileUploadComponent';

const validationSchema = Yup.object().shape({
    CampusName: Yup.string().required("Campus Name is required"),
    NewsTitle: Yup.string().required("Title is required"),
    // file1: Yup.string().required("Please upload a file"),
});


const ProfileContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    padding: theme.spacing(2),
}));


const ResponsiveBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));
const Newsletter = ({ handleAddFormGoBackButton, editById, setEditById }) => {

    const formikRef = useRef();
    const [uploadedFile, setUploadedFile] = useState(null);
    const dispatch = useDispatch()
    console.log(uploadedFile, "uploadedFileuploadedFile")

    const [editResponseData, setEditResponseData] = useState()


    useEffect(() => {


        if (editById) {

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getNewsletterById/${editById}`,
                };
                const response = await dispatch(actions.NEWSLETTERGETBYID(data1));

                console.log(response, "responseresponse")
                const { setFieldValue } = formikRef.current;


                // if (response?.payload?.loading === false && response?.payload?.error === false) {
                if (response?.payload?.message === "Newsletter fetched successfully.") {

                    //     console.log("hiiii")
                    setFieldValue("CampusName", response?.payload?.data?.campus_name);
                    setFieldValue("NewsTitle", response?.payload?.data?.title);
                    // setFieldValue("file1", response?.payload?.data?.fileUrl); // if needed
                    setUploadedFile(response?.payload?.data?.attach_files);
                    // setEditResponseData(response?.payload?.data)
                    // setUploadedFile({
                    //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
                    //     type: "img",
                    //     progress: 100,
                    // }
                    // )
                    //     console.log(response?.payload?.data.additional_data[0]?.banner, "yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, []);



    const campusName = [
        { value: "Campus", label: "Campus" },

    ];

    const countries = [
        { value: "India", label: "India" },
        { value: "USA", label: "USA" },
        { value: "UK", label: "UK" },
        { value: "Australia", label: "Australia" },
    ];


    const blobUrlToFile = async (blobUrl, fileName) => {
        const response = await fetch(blobUrl);
        const blob = await response.blob();
        return new File([blob], fileName, { type: blob.type });
    };

    // const handleSubmit = async (values, { resetForm }) => {
    //     console.log("Form Values of contact form:", values);

    //     const formData = new FormData();

    //     formData.append("campusname", values?.CampusName);
    //     formData.append("newsletter_title", values?.NewsTitle);
    //     const file = await blobUrlToFile(values.file1, "uploaded-file.pdf"); // Change filename and extension as needed
    //     formData.append("pdf_file", file);



    //     const data1 = {
    //         data: formData,
    //         method: "post",
    //         apiName: editById ? `newsletter/${editById}` : `newsletter`,
    //         isFormData: true,
    //     };

    //     const responseData = await dispatch(actions.NEWSLETTERPOST(data1));
    //     if (responseData?.payload?.error === false && responseData?.payload?.loading === false) {
    //         toast.success(`News Letter is ${editById ? "updated" : "created"} successfully`)
    //         handleAddFormGoBackButton()

    //         resetForm();
    //         setUploadedFile(null)
    //     }
    //     else {
    //         toast.error(`News Letter is not ${editById ? "updated" : "created"}`)

    //     }

    // };
    const [loading, setLoading] = useState(false);
    const sessionAdminId = sessionStorage.getItem("adminId")

    const handleSubmit = async (values, { resetForm }) => {
        console.log("Form Values of contact form:", values);
        setLoading(true)
        const formData = new FormData();
        formData.append("campusname", values?.CampusName);
        formData.append("newsletter_title", values?.NewsTitle);

        // Append the file only if the user has uploaded a new one
        if (values?.file1 && values?.file1.startsWith?.("blob:")) {
            const file = await blobUrlToFile(values.file1, "uploaded-file.pdf");
            formData.append("pdf_file", file);
        }

        const data1 = {
            data: {
                user_id: Number(sessionAdminId),
                campus_name: values?.CampusName,
                title: values?.NewsTitle,
                attach_files: uploadedFile,

            },
            // method: "post",
            method: editById ? "put" : "post",

            apiName: editById ? `updateNewsletter/${editById}` : `createNewsletter`,
            isFormData: true,
        };

        const responseData = await dispatch(editById ? actions.UPDATNEWSLETER(data1) : actions.NEWSLETTERPOST(data1));

        // if (responseData?.payload?.error === false && responseData?.payload?.loading === false) {
        if (responseData?.payload?.message === editById ? "Newsletter updated successfully." : "Newsletter posted successfully.") {

            setLoading(false)
            toast.success(`Neweletter ${editById ? "updated" : "created"} successfully`);

            // toast.success(`News Letter is ${editById ? "updated" : "created"} successfully`);

            setTimeout(() => {
                handleAddFormGoBackButton();
                resetForm();
                setUploadedFile(null);
                setEditById(null)
            }, 1500);
        } else {
            setLoading(false)
            toast.error(`Newsletter is not ${editById ? "updated" : "created"}`);
        }
    };

    return (
        <Box>
            <Box>
                {loading && <FullPageLoader />}

                <ProfileContainer p={{ xs: 0 }} mb={2} >
                    <Container maxWidth="lg" >
                        <ResponsiveBox mt={2}>
                            <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
                                <Typography variant="h6" gutterBottom>NewsLetter</Typography>
                                <Divider />
                                <Box>
                                    <Formik
                                        innerRef={formikRef}
                                        initialValues={{
                                            CampusName: "",
                                            NewsTitle: "",
                                            file1: "",
                                        }}
                                        validationSchema={validationSchema}
                                        onSubmit={handleSubmit}
                                    >
                                        {({ isSubmitting, values, resetForm, setFieldValue, errors, touched, handleChange, handleBlur }) => (
                                            <Form>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 2,
                                                        mt: 2
                                                    }}
                                                >


                                                    <Grid container spacing={2}>
                                                        <Grid item size={{ md: 4, xs: 12, sm: 6 }} >
                                                            <CustomInputLogin
                                                                label="Campus Name"
                                                                name="CampusName"
                                                                inputType="text"
                                                                // options={campusName}
                                                                custPlaceholder="Enter Campus Name"
                                                            // image={country_icon}
                                                            // important={true}
                                                            />
                                                        </Grid>
                                                        <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                            <CustomInputLogin
                                                                label="News Letter Title"
                                                                name="NewsTitle"
                                                                custPlaceholder="Enter News Letter Title"
                                                                inputType="input"
                                                            // image={email_input_icon}
                                                            />
                                                        </Grid>


                                                        <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                            <MultipleFileUploadComponent
                                                                uploadedFiles={uploadedFile}
                                                                setUploadedFiles={setUploadedFile}
                                                                onFilesChange={(files) => {
                                                                    console.log("Uploaded files:", files);
                                                                }}
                                                            />
                                                        </Grid>


                                                        {/* <Grid size={{ md: 4, xs: 12, sm: 0 }}></Grid>
                                                        <Grid size={{ md: 4, xs: 12, sm: 6 }}></Grid> */}

                                                        <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "end" }}>
                                                            <Button
                                                                onClick={() => {
                                                                    resetForm()
                                                                    handleAddFormGoBackButton()
                                                                    setEditById(null)
                                                                }}
                                                                variant="contained"
                                                                sx={{
                                                                    textTransform: "none",
                                                                    color: "black",
                                                                    fontSize: "16px",
                                                                    padding: { xs: "0px 20px", md: "0px 50px" },
                                                                    marginRight: "5px",
                                                                    boxShadow: 1,
                                                                    border: "1px solid #ced4da",
                                                                    minHeight: "40px",
                                                                    // borderRadius: "23px",
                                                                    background: "white 0% 0% no-repeat padding-box",
                                                                    "&:hover": {
                                                                        backgroundColor: "white",
                                                                    },
                                                                }}
                                                            >
                                                                Go back
                                                            </Button>
                                                            <Button
                                                                type="submit"
                                                                variant="contained"
                                                                sx={{
                                                                    textTransform: "none",
                                                                    color: "white",
                                                                    fontSize: "16px",
                                                                    padding: { xs: "0px 20px", md: "0px 50px" },

                                                                    boxShadow: "none",
                                                                    minHeight: "40px",
                                                                    // borderRadius: "23px",
                                                                    background: "var(--main-color) 0% 0% no-repeat padding-box",
                                                                    "&:hover": {
                                                                        backgroundColor: "var(--main-color)",
                                                                    },
                                                                }}
                                                            >
                                                                Submit
                                                            </Button>
                                                        </Grid>

                                                    </Grid>




                                                </Box>
                                            </Form>
                                        )}
                                    </Formik>
                                </Box>
                            </Paper>
                        </ResponsiveBox>
                    </Container>
                </ProfileContainer>
            </Box>
            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />

        </Box>
    )
}

export default Newsletter